module.exports = __webpack_public_path__ + "images/stickers/pete-vacation.c50c5371bb78862a587a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-vacation.png
// module id = Yxfp
// module chunks = 0